import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { createTextFieldBorderColors } from '../../constants';
import { variantFilled, variantFlushed, variantOutlined } from '../../focusShim';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(inputAnatomy.keys);
export const unifiedInputStyle = Object.assign({
  backgroundColor: 'GREYSCALE.SUPERNOVA !important'
}, variantFilled());
const baseStyle = definePartsStyle(() => {
  return {
    field: Object.assign({}, unifiedInputStyle, {
      border: 'none',
      _focus: unifiedInputStyle,
      _visited: unifiedInputStyle,
      _blur: unifiedInputStyle,
      _invalid: {
        border: '1px solid',
        borderColor: 'KYOTO.regular !important'
      }
    })
  };
});
const xl = defineStyle({
  fontSize: 'lg',
  px: '4',
  h: '14',
  borderRadius: 'lg'
});
const sizes = {
  xl: definePartsStyle({
    field: xl,
    addon: xl
  })
};
const highlighted = definePartsStyle({
  field: Object.assign({
    border: '1px solid'
  }, createTextFieldBorderColors())
});
const pill = definePartsStyle({
  field: Object.assign({
    borderRadius: 'full',
    border: '1px solid'
  }, variantOutlined())
});
const outline = definePartsStyle(() => {
  return {
    field: {
      _focus: Object.assign({}, createTextFieldBorderColors()),
      _focusVisible: Object.assign({
        shadow: 'none'
      }, createTextFieldBorderColors())
    }
  };
});
const flushed = definePartsStyle(() => {
  return {
    field: {
      _focus: variantFlushed()
    }
  };
});
export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    highlighted,
    pill,
    outline,
    flushed
  },
  sizes
});